import React, {useCallback} from "react"
import {makeStyles} from "@material-ui/core/styles"
import {purple, brown, teal} from "@material-ui/core/colors"
import Typography from "@material-ui/core/Typography"
import Slider from "@material-ui/core/Slider"
import {useStore, useDispatch} from "../Store"
import "../i18n"
import {useTranslation} from "react-i18next"

export default function MovementAverageBar() {
  const {t} = useTranslation()
  let {
    store: {mainTerm, maTerm, maDay, perspective},
  } = useStore()
  const {dispatch} = useDispatch()

  const changeSilideBar = (day) => (event, afterDay) => {
    maDay[perspective][day] = afterDay
    dispatch({
      type: `MOVEMENT_AVERAGE_DAY`,
      maDay,
    })
  }
  
  const moveAverages = {
    "D": {
      values: [ [ 0, 50, 100 ], [ 50, 100, 150 ], [ 100, 200, 300] ],
      step: 5,
      label: `days`
    },
    "W": {
      values: [ [ 0, 13, 26 ], [ 13, 26, 39 ], [ 26, 52, 78 ] ],
      step: 1,
      label: `weeks`
    },
    "M": {
      values: [ [ 0, 12, 24 ], [ 12, 24, 36 ], [ 36, 60, 84 ] ],
      step: 5,
      label: `months`
    },
    "Q": {
      values: [ [ 0, 6, 12 ], [ 6, 12, 18 ], [ 12, 24, 32 ] ],
      step: 1,
      label: `quoters`
    },
  }

  const term = (mainTerm[perspective].key ?? `D`).substr(0, 1)
  const moveAv = moveAverages[term]
  const marks = Object.values(moveAv.values).map((r, i) => {
    return r.map((v) => {
      return {
        value: v,
        label: `${t(moveAv.label)}` /* i18next-extract-disable-line */
      }
    })
  })

  const useStyles = makeStyles(() => ({
    root: {
      width: `85%`,
      marginTop: `40px`,
      color: (props) => props.color,
      zIndex: 0,
    },
    valueLabel: `red`,
  }))
  const moveClasses = [
    useStyles({ color: purple[500] }),
    useStyles({ color: brown[500] }),
    useStyles({ color: teal[500] }),
  ]

  const maDaySlider = useCallback((classes, day, step, mark, ma) => {
    return (
      <>
        <Slider
          className={classes.root}
          defaultValue={mark[1].value}
          min={mark[0].value}
          max={mark[2].value}
          value={ma}
          valueLabelDisplay="on"
          onChange={changeSilideBar(day)}
          marks={mark}
          step={step}
        />
      </>
    )
  })

  const b = maTerm[perspective] !== moveAv.label
  if (b) {
    maTerm[perspective] = moveAv.label
    dispatch({
      type: `MOVEMENT_AVERAGE_TERM`,
      maTerm
    })
    maDay[perspective] = Object.values(moveAv.values).map((v) => { return v[1] })
    dispatch({
      type: `MOVEMENT_AVERAGE_DAY`,
      maDay
    })
  }

  const maD = maDay[perspective]
  return (
    <>
      {maDaySlider(moveClasses[0], 0, moveAv.step, marks[0], b ? marks[0].value : maD[0])}
      {maDaySlider(moveClasses[1], 1, moveAv.step, marks[1], b ? marks[1].value : maD[1])}
      {maDaySlider(moveClasses[2], 2, moveAv.step, marks[2], b ? marks[2].value : maD[2])}
      <Typography>{t(`maDay`)}</Typography>
    </>
  )
}
